"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pclnDesignSystem = require("pcln-design-system");

var _FormatPrice = require("../../../../utils/FormatPrice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function SavingsBanner(_ref) {
  var className = _ref.className,
      savedAmount = _ref.savedAmount,
      currencyCode = _ref.currencyCode,
      currencySymbol = _ref.currencySymbol,
      backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      estimatedFootnote = _ref.estimatedFootnote;
  return _react["default"].createElement(_pclnDesignSystem.Banner, {
    className: className,
    showIcon: false,
    bg: backgroundColor,
    px: 3,
    py: 2
  }, _react["default"].createElement(_pclnDesignSystem.Flex, null, _react["default"].createElement(_pclnDesignSystem.Text, {
    color: color,
    fontSize: 0
  }, "You Saved ", currencySymbol, (0, _FormatPrice.formatPrice)(savedAmount.toFixed(2)), " ", currencyCode === 'USD' || currencyCode), estimatedFootnote && _react["default"].createElement(_pclnDesignSystem.Text, {
    color: color,
    fontSize: estimatedFootnote === '*' ? 1 : '8px'
  }, estimatedFootnote)));
}

SavingsBanner.displayName = 'SavingsBanner';
SavingsBanner.propTypes = {
  className: _propTypes["default"].string,
  savedAmount: _propTypes["default"].number.isRequired,
  currencyCode: _propTypes["default"].string,
  currencySymbol: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  color: _propTypes["default"].string,
  estimatedFootnote: _propTypes["default"].string
};
SavingsBanner.defaultProps = {
  className: '',
  backgroundColor: '#87000A',
  color: 'white',
  currencySymbol: '$',
  currencyCode: 'USD'
};

var _default = (0, _react.memo)(SavingsBanner);

exports["default"] = _default;